<template>
  <v-card class="page-root pa-0 ma-0 d-flex flex-column">
    <!-- nav section -->
    <v-container
      class="nav pa-4 mb-3 pa-0 ma-0 d-flex justify-space-between align-center"
      style="width: 100%"
    >
      <!-- Right Section -->
      <v-container class="ma-0 pa-0 d-flex align-center gap-1" style="flex-wrap: nowrap">
        <v-card-text
          class="pa-0 px-3 ma-0 text-body-1"
          style="font-weight: 600; color: #333"
        >
          {{ $t("Online Menu Settings") }}
        </v-card-text>
        <v-select
          v-model="selectedBranch"
          :items="branchArray"
          item-text="name"
          outlined
          height="38"
          :label="$t('Choose the first branch title from the branch list')"
          hide-details
          density="comfortable"
          style="width: 270px"
          return-object
        ></v-select>
        <v-card-text
          class="px-3 pa-0 ma-0"
          style="font-size: 12px; color: #99999 text-align: right"
        >
          <v-icon start small>mdi-information</v-icon>
          {{ $t("Choose the branch you want") }}
        </v-card-text>
      </v-container>

      <!-- Left Buttons -->
      <v-container class="ma-0 pa-0 d-flex align-center gap-2">
        <v-btn
          outlined
          small
          color="primary"
          height="35"
          @click="copyLink(`https://abr.abriron.com/onlineShop/${uid}/`)"
        >
          {{ $t("copy-link") }}
          <v-icon class="px-1" small>mdi-link-variant</v-icon>
        </v-btn>

        <v-btn
          :loading="loading"
          outlined
          color="primary"
          height="35"
          small
          @click="downloadQrCode('https://abr.abriron.com/onlineShop/')"
        >
          {{ $t("QRcode") }}
          <v-icon class="px-1" small>mdi-qrcode</v-icon>
        </v-btn>

        <v-btn
          :loading="loading"
          small
          color="primary"
          height="35"
          @click="SaveSetting()"
        >
          {{ $t("Save and Publish") }}
          <v-icon class="px-1" small>mdi-content-save</v-icon>
        </v-btn>
      </v-container>
    </v-container>

    <!--tabs menu setting -->
    <v-tabs v-model="tab" class="custom-tabs">
      <!--titles tabs menu setting -->
      <v-tab class="custom-tab text-body-2">{{ $t("general") }}</v-tab>
      <v-tab class="custom-tab text-body-2">{{ $t("Structure and Display") }}</v-tab>
      <v-tab class="custom-tab text-body-2">{{ $t("invoice") }}</v-tab>
      <v-tab class="custom-tab text-body-2">{{ $t("payment") }}</v-tab>
      <!--public -->
      <v-tab-item>
        <v-form class="rtl pa-8 ma-0 d-flex flex-column gap-6">
          <!-- active and deActive section  -->
          <v-container class="pa-0 ma-0 d-flex align-center gap-5">
            <v-card-text class="pa-0 ma-0 text-body-1">{{
              $t("Online Menu Status")
            }}</v-card-text>
            <v-container class="pa-0 wrapper ma-0">
              <div
                v-for="(item, index) in statusOptions"
                :key="index"
                class="flex-fill pa-3 d-flex justify-center"
                @click="selectOption(item)"
                :style="{
                  'background-color': selectedOption == item.value ? '#E5FEED' : '',
                  'border-color': selectedOption == item.value ? '#E5FEED' : 'silver',
                  color: selectedOption == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">
                  {{ item.label }}
                </v-card-text>
              </div>
            </v-container>
          </v-container>

          <!-- add branch name  -->
          <v-container class="pa-0 ma-0">
            <v-text-field
              v-model="branchName"
              class="rtl-text"
              style="max-width: 302px"
              hide-details="auto"
              clearable
              outlined
              height="38"
              :label="$t('Branch Display Name')"
            />
          </v-container>

          <!-- copy public link branch  -->
          <v-container class="pa-0 ma-0 d-flex align-center gap-3">
            <v-text-field
              v-model="publicLink"
              @blur="fillUidEmpty"
              class="rtl-text"
              style="max-width: 302px"
              hide-details="auto"
              clearable
              outlined
              height="38"
              :label="$t('Branch Public Menu Link')"
            />
            <v-card-text class="ma-0 px-2 pa-0 text-body-1" dir="ltr"
              >https://abr.abriron.com/onlineShop/{{ uid }}</v-card-text
            >
            <v-btn
              @click="copyLink(`https://abr.abriron.com/onlineShop/${uid}/`)"
              outlined
              height="35"
              color="#F2F9FF"
              class="black--text"
            >
              <v-icon small color="#888">mdi-content-copy</v-icon>
              {{ $t("copy-link") }}
            </v-btn>
          </v-container>

          <!-- desc about shop -->
          <v-container class="pa-0 ma-0 d-flex">
            <v-textarea
              v-model="shopDescription"
              :label="$t('Short Store Description')"
              outlined
              clearable
              rows="4"
              style="max-width: 492px"
              class="mb-6"
            ></v-textarea>
          </v-container>

          <!-- upload section  -->
          <v-container class="pa-0 ma-0 d-flex align-start">
            <!-- upload two -->
            <v-container class="ma-0 pa-0 d-flex align-center">
              <v-container class="pa-0 ma-0">
                <img
                  :src="iconUrl || require('@/assets/shopping/placeHolderImage.png')"
                  alt="img"
                  height="82"
                  width="82"
                  loading="lazy"
                />
                <input
                  type="file"
                  ref="iconInput"
                  accept="image/*"
                  class="hidden-input"
                  @change="IconSelected"
                />
              </v-container>
              <v-container class="d-flex flex-column gap-1 align-start">
                <v-btn small outlined color="gray" text @click="removeIcon()">
                  {{ $t("Remove Image") }}
                </v-btn>
                <v-btn small outlined color="gray" text @click="newIconUpload()">
                  {{ $t("Upload New Image") }}
                </v-btn>
                <v-card-text class="pa-0 ma-0 text-body-2 grey--text mt-2">
                  {{ $t("Supported formats: PNG, JPG – Max file size: 2 MB") }}
                </v-card-text>
              </v-container>
            </v-container>
            <!-- upload one -->
            <v-container class="mr-6 pa-0 d-flex align-center">
              <v-container class="pa-0 ma-0">
                <img
                  :src="coverUrl || require('@/assets/shopping/placeHolderImage.png')"
                  alt="img"
                  height="82"
                  width="252"
                  loading="lazy"
                />
                <input
                  type="file"
                  ref="coverInput"
                  accept="image/*"
                  class="hidden-input"
                  @change="CoverSelected"
                />
              </v-container>
              <v-container class="d-flex flex-column gap-1 align-start">
                <v-btn small outlined color="gray" text @click="removeCover()">
                  {{ $t("Remove Image") }}
                </v-btn>
                <v-btn small outlined color="gray" text @click="newCoverUpload()">
                  {{ $t("Upload New Image") }}
                </v-btn>
                <v-card-text class="pa-0 ma-0 text-body-2 grey--text mt-2">
                  {{ $t("Supported formats: PNG, JPG – Max file size: 2 MB") }}
                </v-card-text>
              </v-container>
            </v-container>
          </v-container>
        </v-form>
      </v-tab-item>
      <!--structure -->
      <v-tab-item>
        <v-container class="pa-8 ma-0 d-flex flex-column gap-6">
          <!--product availble -->
          <v-container class="pa-0 ma-0 d-flex align-end gap-2">
            <v-checkbox
              v-model="stockProducts"
              :true-value="'active'"
              :false-value="'deactive'"
              hide-details
              class="ma-0 pa-0"
              color="#1976d2"
            />
            <v-card-text class="pa-0 ma-0 text-body-2">
              {{ $t("Show Available Items Only") }}
            </v-card-text>
          </v-container>
          <!--hide product with 0 price -->
          <v-container class="pa-0 ma-0 d-flex align-end gap-2">
            <v-checkbox
              v-model="WithZeroPrice"
              :true-value="'active'"
              :false-value="'deactive'"
              hide-details
              class="ma-0 pa-0"
              color="#1976d2"
            />
            <v-card-text class="pa-0 ma-0 text-body-2">
              {{ $t("Hide items with price 0") }}
            </v-card-text>
          </v-container>

          <!--drag and drop -->
          <group-selector
            @update:displayedGroups="onGroupsChange"
            :displayed-groups="selectedGroups"
          />
        </v-container>
      </v-tab-item>
      <!--invoice -->
      <v-tab-item>
        <v-container class="pa-8 ma-0 rtl d-flex flex-column gap-5">
          <!-- title -->
          <v-card-text class="pa-0 ma-0 text-body-1">
            {{ $t("invoice-setting") }}
          </v-card-text>
          <!-- select the Repository -->
          <v-container class="d-flex gap-4 pa-0 ma-0">
            <v-card-text class="pa-0 ma-0 mt-2 text-body-2">
              {{ $t("chose-entrepot") }}
            </v-card-text>
            <v-select
              v-model="selectedRepository"
              :items="selectedRepositoryArray"
              item-text="name"
              :label="$t('Repo Title for This Branch')"
              outlined
              hide-details="auto"
              class="rtl-text"
              style="max-width: 302px"
              height="38"
              :rules="[() => !!selectedRepository || this.$t('is-required')]"
              required
              return-object
            >
            </v-select>
          </v-container>
          <!-- pay on site  -->
          <v-container class="pa-0 ma-0 gap-4 d-flex align-center">
            <v-card-text class="pa-0 ma-0 text-body-2">
              {{ $t("payment-on-site") }}
            </v-card-text>
            <v-container class="pa-0 wrapper ma-0" style="width: 230px">
              <div
                v-for="(item, index) in Selloptions"
                :key="index"
                class="flex-fill pa-3 d-flex justify-center"
                @click="selectSellOption(item)"
                :style="{
                  'background-color': selectedSellOption == item.value ? '#0066FF' : '',
                  'border-color': selectedSellOption == item.value ? '#0066FF' : 'silver',
                  color: selectedSellOption == item.value ? '#fff' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">
                  {{ item.label }}
                </v-card-text>
              </div>
            </v-container>
          </v-container>
          <!-- send sms -->
          <v-container class="d-flex align-end pa-0 ma-0 gap-4">
            <v-checkbox
              v-model="sendSms"
              :true-value="'active'"
              :false-value="'deactive'"
              hide-details
              class="ma-0 pa-0"
              color="#1976d2"
            />
            <v-card-text class="pa-0 ma-0 text-body-2">
              {{ $t("Automatically send invoice SMS") }}
            </v-card-text>
          </v-container>
          <!--printer setting-->
          <v-card-text class="pa-0 text-body-1">{{ $t("printer-setting") }}</v-card-text>
          <v-container
            class="box-print px-3 py-2 ma-0"
            style="height: 70px; width: 490px"
          >
            <v-container class="pa-0 d-flex justify-space-between">
              <v-card-text class="pa-0 text-body-2">{{
                $t("choose-printer")
              }}</v-card-text>
              <div>
                <v-autocomplete
                  v-model="selectedPrinter"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :label="$t('chose-device')"
                  class="mt-2 printer-device"
                  outlined
                  :items="printerList"
                  item-text="Name"
                  item-value="Key"
                  return-object
                />
              </div>
            </v-container>
          </v-container>
        </v-container>
      </v-tab-item>
      <!--peyment -->
      <v-tab-item>
        <v-container class="pa-8 ma-0 d-flex flex-column gap-6">
          <v-container class="pa-0 ma-0 rtl d-flex flex-column gap-3">
            <!-- title -->
            <v-card-text class="pa-0 ma-0 text-body-1">
              {{ $t("payment way") }}
            </v-card-text>
            <!-- payment on site  active and deactive -->
            <v-container class="pa-0 ma-0 gap-11 d-flex align-center">
              <v-card-text class="pa-0 ma-0 text-body-2">
                {{ $t("paymentinplace") }}
              </v-card-text>
              <v-container class="pa-0 wrapper ma-0">
                <div
                  v-for="(item, index) in OnsiteOptions"
                  :key="index"
                  class="flex-fill pa-3 d-flex justify-center"
                  @click="selectOnsiteOption(item)"
                  :style="{
                    'background-color':
                      selectedOnsiteOption == item.value ? '#E5FEED' : '',
                    'border-color':
                      selectedOnsiteOption == item.value ? '#E5FEED' : 'silver',
                    color: selectedOnsiteOption == item.value ? '#137333' : '',
                  }"
                >
                  <v-card-text class="pa-0 text-caption">
                    {{ item.label }}
                  </v-card-text>
                </div>
              </v-container>
            </v-container>
            <!-- payment online  active and deactive -->
            <v-container class="pa-0 ma-0 gap-12 d-flex align-center">
              <v-card-text class="pa-0 ma-0 text-body-2">{{
                $t("online peyment")
              }}</v-card-text>
              <v-container class="pa-0 wrapper ma-0">
                <div
                  v-for="(item, index) in OnlineOptions"
                  :key="index"
                  class="flex-fill pa-3 d-flex justify-center"
                  @click="selectOnlineOption(item)"
                  :style="{
                    'background-color':
                      selectedOnlineOption == item.value ? '#E5FEED' : '',
                    'border-color':
                      selectedOnlineOption == item.value ? '#E5FEED' : 'silver',
                    color: selectedOnlineOption == item.value ? '#137333' : '',
                  }"
                >
                  <v-card-text class="pa-0 text-caption">
                    {{ item.label }}
                  </v-card-text>
                </div>
              </v-container>
            </v-container>
            <!--payment by card-->
            <v-container class="pa-0 ma-0 d-flex align-center gap-8">
              <v-card-text class="pa-0 text-body-2 mt-3">{{
                $t("pay-by-card")
              }}</v-card-text>
              <v-container class="pa-0 wrapper ma-0 mt-3" style="width: 165px !important">
                <div
                  v-for="(item, index) in statusOptions"
                  :key="index"
                  class="flex-fill pa-2 d-flex justify-center"
                  @click="selectStatusCard(item)"
                  :style="{
                    'background-color':
                      cardReaderStatus == item.value ? 'rgb(229, 254, 237)' : '',
                    'border-color': cardReaderStatus == item.value ? 'silver' : 'silver',
                    color: cardReaderStatus == item.value ? 'rgb(19, 115, 51)' : '',
                  }"
                >
                  <v-card-text class="pa-0 text-caption">
                    {{ item.label }}
                  </v-card-text>
                </div>
              </v-container>
            </v-container>

            <v-container class="pa-0 ma-0" v-if="showPosDetails">
              <v-card class="pa-5">
                <v-form ref="posForm">
                  <v-card-text class="pa-0 text-caption mb-7">{{
                    $t("pos-info")
                  }}</v-card-text>
                  <v-text-field
                    v-model="posSetting.posName"
                    :label="$t('caption')"
                    :rules="[(v) => !!v || $t('is-required')]"
                    outlined
                    dense
                    clearable
                    class="mt-2 mb-8"
                  />
                  <v-text-field
                    v-model="posSetting.posIp"
                    :label="$t('PosIp')"
                    outlined
                    dense
                    :rules="[(v) => !!v || $t('is-required')]"
                    clearable
                  />
                  <v-text-field
                    v-model="posSetting.posPort"
                    :label="$t('PosPort')"
                    outlined
                    dense
                    clearable
                    class="my-8"
                    :rules="[(v) => !!v || $t('is-required')]"
                  />
                  <autocomplete
                    v-model="posSetting.bank"
                    :rules="[(v) => !!v || $t('is-required')]"
                    :title="$t('chose-bank')"
                    type="bankCash"
                    class="mt-8"
                  />
                  <v-autocomplete
                    v-model="posSetting.posDevice"
                    :rules="[(v) => !!v || $t('is-required')]"
                    :label="$t('chose-device')"
                    class="mt-8 pos-device"
                    outlined
                    :items="posesList"
                    item-text="Name"
                    item-value="Key"
                    return-object
                  />
                  <v-container class="pa-0 d-flex align-center gap-2 mt-4">
                    <v-btn
                      color="primary"
                      height="32"
                      :loading="loading"
                      @click="addPosDevice"
                    >
                      {{ $t("confirm") }}
                    </v-btn>
                    <v-btn color="secondary" outlined height="32">
                      {{ $t("cancel") }}
                    </v-btn>
                  </v-container>
                </v-form>
              </v-card>
            </v-container>

            <!--selected peyment way -->
            <!-- <v-container class="d-flex flex-column pa-0 ma-0 gap-3">
              <v-container
                v-for="(gateway, i) in gatewaysList"
                :key="i"
                class="d-flex align-end pa-0 ma-0"
              >
                <v-checkbox
                  v-model="gateway.value"
                  hide-details
                  class="ma-0 pa-0"
                  color="#1976d2"
                />
                <v-card-text class="pa-0 ma-0">{{ $t(gateway.label) }}</v-card-text>
              </v-container>
            </v-container> -->
          </v-container>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <!--  snackbar --->
    <v-snackbar
      v-if="snakbar"
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="loading"
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import GroupSelector from "./partial/GroupSelector.vue";
import mixin from "../../../../Mixins/mixin";
import general from "../../../../Mixins/general";
import QRCode from "qrcodejs2";

export default {
  name: "settingMenu",
  mixins: [mixin, general],
  components: { GroupSelector },
  data() {
    return {
      tab: 0,
      selectedOption: "active",
      selectedSellOption: "sell",
      selectedOnlineOption: "active",
      selectedOnsiteOption: "active",
      WithZeroPrice: "deactive",
      stockProducts: "deactive",
      sendSms: "deactive",
      shopDescription: "",
      selectedRepositoryArray: [],
      branchArray: [],
      selectedGroups: [],
      branchName: null,
      iconUrl: null,
      coverUrl: null,
      iconFile: null,
      coverFile: null,
      uid: null,
      selectedBranch: "",
      selectedRepository: null,
      publicLink: null,
      gatewayKeys: [
        "zibal",
        "zarinpal",
        "saman",
        "mellat",
        "pasargard",
        "parsian",
        "digipay",
        "snapp_pay",
        "sadad",
        "payping",
        "sepehr",
        "iran_kish",
        "iran_kish_token",
        "zarin_plus",
      ],
      gatewaysList: [],
      printerList: null,
      selectedPrinter: null,
      cardReaderStatus: null,
      showPosDetails: false,
      posSetting: {
        posName: null,
        posIp: null,
        posPort: null,
        bank: null,
        posDevice: null,
      },
      posesList: [],
      loading: false,
      snakbar: false,
      snakbarColor: null,
      snakbarText: null,
    };
  },
  computed: {
    statusOptions() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
    Selloptions() {
      return [
        { label: this.$t("sell"), value: "sell" },
        { label: this.$t("presale"), value: "presale" },
      ];
    },
    OnlineOptions() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
    OnsiteOptions() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
  },
  beforeMount() {
    // this.getBranchList();
    this.getRepoList();
  },
  mounted() {
    this.getBranchList();
    // this.getRepoList();
    this.gatewaysList = this.buildGatewaysList();

    this.cardReaderStatus = "deactive";
    if (localStorage.getItem("selectedPrinter")) {
      this.selectedPrinter = localStorage.getItem("selectedPrinter");
    }
    if (localStorage.getItem("posDeviceMenu")) {
      this.posSetting = JSON.parse(localStorage.getItem("posDeviceMenu"));
      this.cardReaderStatus = localStorage.getItem("isPosActive");
    }
  },
  watch: {
    selectedBranch(newVal) {
      if (!newVal || !newVal.id) return;
      this.selectedBranch = newVal;
      this.getSetting();
      this.getRepoList();
    },
    tab(val) {
      if (val && val == 2) {
        this.getPrinterListBySocket();
      }
    },
    selectedPrinter(val) {
      localStorage.setItem("selectedPrinter", val);
    },
    cardReaderStatus(val) {
      if (val == "active") {
        this.getPosesListBySocket();
        this.showPosDetails = true;
      } else {
        this.showPosDetails = false;
      }
    },
  },
  methods: {
    buildGatewaysList(selectedKeys = []) {
      return this.gatewayKeys.map((key) => ({
        key,
        label: this.$t(key),
        value: selectedKeys.includes(key),
      }));
    },
    parseGatewayKeys(gateway) {
      if (gateway == null || gateway === "") return [];

      let raw = gateway;
      if (typeof raw === "string") {
        try {
          raw = JSON.parse(raw);
        } catch {
          return [];
        }
        if (typeof raw === "string") {
          try {
            raw = JSON.parse(raw);
          } catch {
            return [];
          }
        }
      }

      if (Array.isArray(raw)) {
        return raw.filter((k) => typeof k === "string");
      }

      if (raw && typeof raw === "object") {
        return Object.values(raw).filter((k) => typeof k === "string");
      }

      return [];
    },
    configPosInSocket() {
      let selectedPos = this.posSetting.posDevice;
      let selectedPosKey;

      if (selectedPos.Key == "EghtesadNovin") {
        selectedPosKey = 0;
      }
      if (selectedPos.Key == "Saman") {
        selectedPosKey = 1;
      }
      if (selectedPos.Key == "BehPardakht") {
        selectedPosKey = 2;
      }
      if (selectedPos.Key == "Fanap") {
        selectedPosKey = 3;
      }
      if (selectedPos.Key == "Parsian") {
        selectedPosKey = 4;
      }
      const socket = new WebSocket("ws://127.0.0.1:8145/Command");
      socket.onopen = () => {
        const message = {
          Key: 1,
          Data: {
            PosIP: this.posSetting.posIp,
            PosPort: this.posSetting.posPort,
            PosType: selectedPosKey,
          },
        };
        socket.send(JSON.stringify(message));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data == 0) {
          // success
          this.loading = false;
          this.snakbarText = this.$t("pos setting submited successfully!");
          this.snakbarColor = "green";
          this.snakbar = true;
        } else {
          // failed
          this.loading = false;
        }
      };
    },
    addPosDevice() {
      if (this.$refs.posForm.validate()) {
        this.loading = true;
        localStorage.setItem("posDeviceMenu", JSON.stringify(this.posSetting));
        localStorage.setItem("isPosActive", this.cardReaderStatus);
        this.configPosInSocket();
      }
    },
    getPosesListBySocket() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Query");
      socket.onopen = () => {
        socket.send(JSON.stringify({ Key: "POSES" }));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        this.posesList = data.Result;
      };
    },
    selectStatusCard(item) {
      this.cardReaderStatus = item.value;
    },
    getPrinterListBySocket() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Query");

      socket.onopen = () => {
        socket.send(JSON.stringify({ Key: "PRINTERQUERY" }));
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        this.printerList = data.Result;
      };
    },
    generateUID() {
      return Math.random().toString(36).substring(2, 10);
    },
    fillUidEmpty() {
      if (!this.publicLink || this.publicLink.trim() == "") {
        this.publicLink = this.generateUID();
      }
    },
    onGroupsChange(val) {
      this.selectedGroups = val;
    },
    copyLink(link) {
      if (this.publicLink) {
        const finalUrl = link + (this.publicLink || "");
        navigator.clipboard.writeText(finalUrl);
        this.copied();
      } else {
        this.snakbarText = this.$t("Please fill the link and select your branch");
        this.snakbarColor = "red";
        this.snakbar = true;
      }
    },
    selectOption(item) {
      this.selectedOption = item.value;
    },
    selectSellOption(item) {
      this.selectedSellOption = item.value;
    },
    selectOnlineOption(item) {
      this.selectedOnlineOption = item.value;
    },
    selectOnsiteOption(item) {
      this.selectedOnsiteOption = item.value;
    },
    downloadQrCode(link) {
      var app = this;
      app.loading = true;
      if (!this.publicLink || !this.uid) {
        this.snakbarText = this.$t("Please fill the link and select your branch");
        this.snakbarColor = "red";
        this.snakbar = true;
        this.loading = false;
        return;
      }
      const finalUrl = link + this.uid + "/" + this.publicLink;
      const tempDiv = document.createElement("div");
      tempDiv.style.position = "absolute";
      tempDiv.style.left = "-9999px";
      document.body.appendChild(tempDiv);
      // generate QR
      const qr = new QRCode(tempDiv, {
        text: finalUrl,
        width: 600,
        height: 600,
        correctLevel: QRCode.CorrectLevel.H,
      });
      setTimeout(() => {
        const img = tempDiv.querySelector("img");
        if (img) {
          const a = document.createElement("a");
          a.href = img.src;
          a.download = `qrcode_${this.uid}.png`;
          a.click();
        }
        tempDiv.remove();
        app.loading = false;
      }, 350);
    },
    getBranchList() {
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "branch/list", {
          params: {
            type: "all",
            options: { itemsPerPage: 1000 },
            page: 1,
          },
        })
        .then((response) => {
          app.loading = false;
          const raw = response.data.data || [];
          const branches = raw.map((item) => {
            return {
              ...item,
              name: item?.name ? item.name : this.$t("no name"),
            };
          });
          this.branchArray = [
            {
              id: "all",
              name: this.$t("No branch filtering"),
            },
            ...branches,
          ];
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
    getRepoList() {
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "warehouse", {
          params: {
            page: 1,
            options: { page: 1, itemsPerPage: 10000 },
          },
        })
        .then((response) => {
          app.loading = false;
          this.selectedRepositoryArray = response.data.data || [];
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
    //upload & remove icon
    newIconUpload() {
      this.$refs.iconInput.click();
    },
    IconSelected(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.iconFile = file;
      this.iconUrl = URL.createObjectURL(file);
    },
    removeIcon() {
      this.iconFile = null;
      this.iconUrl = null;
      this.$refs.iconInput.value = null;
    },
    //upload & remove cover
    newCoverUpload() {
      this.$refs.coverInput.click();
    },
    CoverSelected(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.coverFile = file;
      this.coverUrl = URL.createObjectURL(file);
    },
    removeCover() {
      this.coverFile = null;
      this.coverUrl = null;
      this.$refs.coverInput.value = null;
    },
    //save setting
    SaveSetting() {
      const gatewaysObject = {};
      let index = 0;
      this.gatewaysList.forEach((gateway) => {
        if (gateway.value == true) {
          gatewaysObject[index++] = gateway.key;
        }
      });
      var app = this;
      app.loading = true;
      if (
        !app.selectedBranch?.id ||
        !app.branchName ||
        !app.publicLink ||
        app.selectedGroups.length == 0
      ) {
        app.snakbarText = app.$t(
          "please select branch set name create link and select your category"
        );
        app.snakbarColor = "red";
        app.snakbar = true;
        app.loading = false;
        return;
      }
      let data = new FormData();
      data.append("branch_id", app.selectedBranch.id);
      data.append("status", app.selectedOption);
      data.append("name", app.branchName);
      data.append("slug", app.publicLink);
      data.append("content", app.shopDescription || "");
      data.append("icon", app.iconFile);
      data.append("cover", app.coverFile);
      data.append("stock_products", app.stockProducts);
      data.append("zero_price", app.WithZeroPrice);
      data.append("entrepot_id", app.selectedRepository?.id || "");
      data.append("invoice_type", app.selectedSellOption || "");
      data.append("auto_sms", app.sendSms);
      data.append("offline_payment", app.selectedOnsiteOption);
      data.append("online_payment", app.selectedOnlineOption);
      data.append("product_category_ids", JSON.stringify(app.selectedGroups));
      data.append("gateway", JSON.stringify(gatewaysObject));
      app.$axios
        .post(app.$endpoint + "menu/setting/store", data, {})
        .then((response) => {
          app.loading = false;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
          app.loading = false;
        })
        .finally(() => {
          app.snakbarText = app.$t("set your setting");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.loading = false;
        });
    },
    //get setting details
    getSetting() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(app.$endpoint + "menu/setting/" + app.selectedBranch.id, {})
        .then((response) => {
          app.uid = response.data.cuid;
          app.loading = false;
          let res = response.data.data;
          if (res == null) {
            this.clearAllFields();
            return;
          }
          app.selectedOption = res.status;
          app.branchName = res.name;
          app.publicLink = res.slug;
          if (app.publicLink == "") {
            app.fillUidEmpty();
          }
          app.shopDescription = res.content;
          app.iconUrl = res.icon?.link;
          app.coverUrl = res.cover?.link;
          app.stockProducts = res.stock_products;
          app.WithZeroPrice = res.zero_price;
          app.selectedGroups = res.product_categories || [];
          app.selectedSellOption = res.invoice_type;
          app.sendSms = res.auto_sms;
          app.selectedOnsiteOption = res.offline_payment;
          app.selectedOnlineOption = res.online_payment;
          app.gatewaysList = app.buildGatewaysList(app.parseGatewayKeys(res.gateway));
          app.selectedRepository =
            app.selectedRepositoryArray.find((repo) => repo.id == res.entrepot_id) ||
            null;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
    clearAllFields() {
      this.tab = 0;
      this.selectedOption = "active";
      this.selectedSellOption = "sell";
      this.selectedOnlineOption = "active";
      this.selectedOnsiteOption = "active";
      this.WithZeroPrice = "deactive";
      this.stockProducts = "deactive";
      this.sendSms = "deactive";
      this.shopDescription = "";
      this.selectedGroups = [];
      this.branchName = null;
      this.iconUrl = null;
      this.coverUrl = null;
      this.iconFile = null;
      this.coverFile = null;
      this.selectedRepository = null;
      this.publicLink = null;
      this.gatewaysList = this.buildGatewaysList();
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.box-print {
  border: 1px solid silver;
  background-color: #f5f2f270;
  border-radius: 4px;
}
::v-deep .v-label {
  top: 10px !important;
}
::v-deep .v-label.v-label--active {
  top: 15px !important;
}
::v-deep.v-btn--icon.v-size--default {
  width: 20px;
  height: 20px;
}
::v-deep .v-slide-group__content {
  background-color: #f3f3f3 !important;
}
::v-deep
  .v-input--selection-controls__input:hover
  .v-input--selection-controls__ripple:before {
  background: #fff;
}
.theme--light.v-tabs > .v-tabs-bar {
  background-color: #eb4e4e;
}
.nav {
  background-color: #ffff;
}
.wrapper {
  border: 1px solid silver;
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: 100%;
}
.wrapper > div {
  border-left: 1px solid silver;
  cursor: pointer;
  width: 80px;
}
.wrapper > div:last-child {
  border-left: 0 !important;
}
.rtl {
  direction: rtl;
  text-align: right;
}
:deep .v-tabs-bar {
  border-radius: inherit;
  height: 42px;
}
:deep .v-tabs {
  flex: none;
}
.custom-tabs :deep(.v-tab:last-child) {
  border-radius: 8px 0px 0px 0px;
}
.custom-tab {
  min-width: 120px;
  padding: 12px 20px;
  border: 1px solid #e0e0e0 !important;
  background-color: #fff !important;
  font-weight: 500;
  color: #333 !important;
}
.custom-tab.v-tab--active {
  background-color: #1976d2 !important;
  color: white !important;
}
.active-btn {
  background-color: #d8f5df !important;
  border-color: #bdeec7 !important;
  color: #2d8a3d !important;
}
.copy-btn {
  background: #f2f9ff !important;
  border: 1px solid #d0e7ff !important;
  border-radius: 6px !important;
}
.v-card__text {
  width: auto;
}
.container {
  width: auto;
}
.hidden-input {
  display: none;
}
</style>
